import React, { cloneElement } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  icon?: React.ReactNode;
  error?: string;
  fullWidth?: boolean;
}
export const Input = ({
  label,
  icon,
  error,
  fullWidth = true,
  className = '',
  ...props
}: InputProps) => {
  return <div className={`${fullWidth ? 'w-full' : ''} mb-4`} data-id="element-2862">
      {label && <label htmlFor={props.id} className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-2863">
          {label}
        </label>}
      <div className="relative" data-id="element-2864">
        {icon && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2865">
            {cloneElement(icon as React.ReactElement, {
          className: 'h-5 w-5 text-neutral-400 dark:text-neutral-500'
        })}
          </div>}
        <input className={`${icon ? 'pl-10' : 'pl-4'} w-full px-4 py-2 rounded-lg bg-white dark:bg-dark-300/50 border border-neutral-200 dark:border-dark-100/30 text-neutral-900 dark:text-white placeholder:text-neutral-400 dark:placeholder:text-neutral-500 focus:outline-none focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent transition-all ${className}`} {...props} data-id="element-2866" />
      </div>
      {error && <p className="mt-1 text-sm text-red-600 dark:text-red-400" data-id="element-2867">{error}</p>}
    </div>;
};